import { ArrowLeft } from "lucide-react";
import { Box, SxProps } from "@mui/system";
import { IconButton } from "@mui/material";
import { ReactNode } from "react";
import useIsMobile from "../hooks/useIsMobile";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";

type Props = {
  onBack?: () => void;
  children?: ReactNode;
  noPaddingBottom?: boolean;
  sx?: SxProps;
  rightAction?: ReactNode;
};
export default ({
  onBack,
  children,
  noPaddingBottom = false,
  sx,
  rightAction,
}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const onClick = () => {
    if (onBack) {
      onBack();
    } else if (window.history.state && window.history.state.idx > 0) {
      const queryParams = new URLSearchParams(location.search);
      // Special case for when we're coming from the creation flow and we want to skip getting stuck in a loop.
      if (queryParams.get("creationRedirect")) {
        navigate(-2);
      } else {
        navigate(-1);
      }
    } else {
      // If we're at the top of the history stack, navigate to the inbox
      const parts = location.pathname.split("/");
      const newPath = parts.slice(0, parts.length - 1).join("/");
      navigate(newPath);
    }
  };
  return (
    <Box
      display="flex"
      flexDirection="row"
      width={"100%"}
      gap="8px"
      alignItems={"center"}
      sx={{
        padding: noPaddingBottom ? "20px 10px 0 10px" : "0px 10px 12px 10px",
        ...sx,
      }}
    >
      {isMobile && (
        <IconButton onClick={onClick}>
          <ArrowLeft />
        </IconButton>
      )}
      <Box display="flex" gap="6px" flexWrap="wrap" width={"100%"}>
        {children}
      </Box>
      {rightAction && (
        <Box
          sx={{
            // Position self at end
            justifySelf: "end",
            marginRight: "12px",
          }}
        >
          {rightAction}
        </Box>
      )}
    </Box>
  );
};
